export { default as XCircleOutlineIcon } from './XCircleOutlineIcon';
